import React from 'react'
import './Home.css'
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <div className="home_container">
                <img className="home_image" alt="Gamer Essentials" src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/June/Fuji_TallHero_Gamers_en_US_1x._CB667161802_.jpg" height="600px" width="1500px" data-a-hires="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2021/June/Fuji_TallHero_Gamers_en_US_2x._CB667161802_.jpg"></img>
                <div className="home_row">
                    <Product  
                    id="12321341" 
                    title="The lean startup: How Constant Innovation Creates Radically Successful Business Paperback" 
                    price={29.99} 
                    image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQx3BIWym5q5kW-7rNV4gQUTzLiYLLH0FGUADd_iM9u6oRVIY18gxxgt5WJLixXYcHctkc&usqp=CAU" 
                    rating={5}/>
                    
                    <Product  
                    id="49538094" 
                    title="Kenwood kMix Stand Mixer for Baking, Stylish Kitchen Mixer with K-beater, Dough Hook and Whisk, 5 Litre Glass Bowl" 
                    price={239.0} 
                    image="https://images-eu.ssl-images-amazon.com/images/I/514EGMqSx-L._AC_UL160_.jpg" 
                    rating={4}/>
                    
                    
                
                </div>
                <div className="home_row">
                    <Product  
                        id="4903850" 
                        title="Playstation DualSense Wireless Controller
                        by PlayStation" 
                        price={66.95}
                        image="https://images-na.ssl-images-amazon.com/images/I/41UK+fp9jcS.jpg" 
                        rating={5}
                    />
                    <Product  
                        id="23445930" 
                        title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric" 
                        price={98.99} 
                        image="https://images-na.ssl-images-amazon.com/images/I/61b4qFTXRML._AC_SX425_.jpg" 
                        rating={5}
                    />
                    <Product  
                        id="3254354345" 
                        title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)" 
                        price={589.99} 
                        image="https://images-na.ssl-images-amazon.com/images/I/81FH2j7EnJL._AC_SL1500_.jpg" 
                        rating={4}
                    />

                </div>
                <div className="home_row">
                <Product  
                        id="90829332" 
                        title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440" 
                        price={1094.98}
                        image="https://images-na.ssl-images-amazon.com/images/I/71MlcO29QOL._AC_SX679_.jpg" 
                        rating={4}
                    />
                </div>
            </div>
        </div>
    )
}

export default Home
